const e = {
  name: "Alternative",
  dimensions: { width: 20, height: 21 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="15.5" cy="16.25" r="3.5" />
      <rect x="12" y="1.75" width="7" height="7" rx="1" stroke-linejoin="round"/>
      <rect x="1" y="1.75" width="7" height="7" rx="1" stroke-linejoin="round"/>
      <rect x="1" y="12.75" width="7" height="7" rx="1" stroke-linejoin="round"/>
    </g>
  `
};
export {
  e as Alternative
};
